import { render } from "./Distinguish.vue?vue&type=template&id=271dfcb0&scoped=true&lang=true"
import script from "./Distinguish.vue?vue&type=script&lang=js"
export * from "./Distinguish.vue?vue&type=script&lang=js"

import "./Distinguish.vue?vue&type=style&index=0&id=271dfcb0&lang=scss&scoped=true"
import "./Distinguish.vue?vue&type=style&index=1&id=271dfcb0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271dfcb0"]])

export default __exports__